module.exports = __webpack_public_path__ + "static/media/bellabyte-brinde-mousepad.a3e6453a.jpg";